var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBenchmarkingPlot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.534 33.9448C16.1695 33.9448 16.6847 33.4296 16.6847 32.7941C16.6847 32.1586 16.1695 31.6434 15.534 31.6434C14.8985 31.6434 14.3833 32.1586 14.3833 32.7941C14.3833 33.4296 14.8985 33.9448 15.534 33.9448Z",
    fill: "#949494"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.6023 23.5887C47.2378 23.5887 47.753 23.0735 47.753 22.438C47.753 21.8025 47.2378 21.2874 46.6023 21.2874C45.9668 21.2874 45.4517 21.8025 45.4517 22.438C45.4517 23.0735 45.9668 23.5887 46.6023 23.5887Z",
    fill: "#949494"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M56.9583 13.2326C57.5938 13.2326 58.109 12.7175 58.109 12.082C58.109 11.4464 57.5938 10.9313 56.9583 10.9313C56.3228 10.9313 55.8076 11.4464 55.8076 12.082C55.8076 12.7175 56.3228 13.2326 56.9583 13.2326Z",
    fill: "#949494"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M56.9584 63.8542V61.5529M5.16992 12.0819H7.47128H5.16992ZM5.16992 22.438H7.47128H5.16992ZM5.16992 32.7941H7.47128H5.16992ZM5.16992 43.1502H7.47128H5.16992ZM5.16992 53.5063H7.47128H5.16992ZM15.5341 63.8542V61.5529V63.8542ZM25.8901 63.8542V61.5529V63.8542ZM36.2462 63.8542V61.5529V63.8542ZM46.6023 63.8542V61.5529V63.8542Z",
    stroke: "#949494",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M67.8508 63.2872H1.1898C0.532688 63.2872 0 63.7853 0 64.3998V64.4758C0 65.0904 0.532688 65.5886 1.1898 65.5886H67.8508C68.5079 65.5886 69.0406 65.0904 69.0406 64.4758V64.3998C69.0406 63.7853 68.5079 63.2872 67.8508 63.2872Z",
    fill: "#949494"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3.45215 1.18964L3.45215 67.8507C3.45215 68.5078 3.95034 69.0405 4.56486 69.0405H4.64079C5.25532 69.0405 5.7535 68.5078 5.7535 67.8507L5.7535 1.18964C5.7535 0.532532 5.25532 -8.39233e-05 4.64079 -8.39233e-05H4.56486C3.95034 -8.39233e-05 3.45215 0.532532 3.45215 1.18964Z",
    fill: "#949494"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.534 33.9448C16.1695 33.9448 16.6847 33.4296 16.6847 32.7941C16.6847 32.1586 16.1695 31.6434 15.534 31.6434C14.8985 31.6434 14.3833 32.1586 14.3833 32.7941C14.3833 33.4296 14.8985 33.9448 15.534 33.9448Z",
    stroke: "#949494",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8904 54.6571C26.5259 54.6571 27.0411 54.1419 27.0411 53.5064C27.0411 52.8709 26.5259 52.3557 25.8904 52.3557C25.2549 52.3557 24.7397 52.8709 24.7397 53.5064C24.7397 54.1419 25.2549 54.6571 25.8904 54.6571Z",
    fill: "#949494"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8904 54.6571C26.5259 54.6571 27.0411 54.1419 27.0411 53.5064C27.0411 52.8709 26.5259 52.3557 25.8904 52.3557C25.2549 52.3557 24.7397 52.8709 24.7397 53.5064C24.7397 54.1419 25.2549 54.6571 25.8904 54.6571Z",
    stroke: "#949494",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2464 44.3009C36.8819 44.3009 37.3971 43.7857 37.3971 43.1502C37.3971 42.5147 36.8819 41.9995 36.2464 41.9995C35.6109 41.9995 35.0957 42.5147 35.0957 43.1502C35.0957 43.7857 35.6109 44.3009 36.2464 44.3009Z",
    fill: "#949494"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2464 44.3009C36.8819 44.3009 37.3971 43.7857 37.3971 43.1502C37.3971 42.5147 36.8819 41.9995 36.2464 41.9995C35.6109 41.9995 35.0957 42.5147 35.0957 43.1502C35.0957 43.7857 35.6109 44.3009 36.2464 44.3009Z",
    stroke: "#949494",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M46.6023 23.5887C47.2378 23.5887 47.753 23.0735 47.753 22.438C47.753 21.8025 47.2378 21.2874 46.6023 21.2874C45.9668 21.2874 45.4517 21.8025 45.4517 22.438C45.4517 23.0735 45.9668 23.5887 46.6023 23.5887Z",
    stroke: "#949494",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M56.9583 13.2326C57.5938 13.2326 58.109 12.7175 58.109 12.082C58.109 11.4464 57.5938 10.9313 56.9583 10.9313C56.3228 10.9313 55.8076 11.4464 55.8076 12.082C55.8076 12.7175 56.3228 13.2326 56.9583 13.2326Z",
    stroke: "#949494",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBenchmarkingPlot);
export default __webpack_public_path__ + "static/media/benchmarkingPlot.aaa460b3167f273f983c71e7406ea7e2.svg";
export { ForwardRef as ReactComponent };